import { useQuery } from "@tanstack/react-query";

import { getMetaFunctions } from "../../services/metaFunction";

const useGetMetaFunctions = (type: string) => {
    const queryFn = async () => {
        return await getMetaFunctions(type);
    }

    return useQuery({
        queryKey: ["meta-functions", type],
        queryFn: queryFn,
        staleTime: Infinity,
    });
}

export default useGetMetaFunctions;